import { mapActions } from 'vuex';
import { formMixin } from '@/components/forms/mixin';
import loaderMixin from '@/mixins/loader';

export default {
  mixins: [
    formMixin,
    loaderMixin,
  ],
  methods: {
    ...mapActions('user', ['agreeToTerms', 'getStatus']),
    ...mapActions('popup', ['setCurrentPopup']),
    onSubmit() {
      if (this.formDisable()) {
        this.loaderAdd(document.body);
        const payload = {
          isNALTermsAgreedTo: true,
        };
        this.agreeToTerms(payload)
          .then(() => this.getStatus())
          .then(() => {
            this.loaderRemove(document.body);
            this.setCurrentPopup();
          })
          .catch((e) => {
            this.loaderRemove(document.body);
            this.formEnable();
            this.formHandleErrors(e);
          });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-enable-classic-predictit/account-enable-classic-predictit.js